import { render, staticRenderFns } from "./material01.vue?vue&type=template&id=543ccc4d&scoped=true&"
import script from "./material01.vue?vue&type=script&lang=js&"
export * from "./material01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543ccc4d",
  null
  
)

export default component.exports